module.exports = __webpack_public_path__ + "img/trend.b0712fa4.svg";